import styled from 'styled-components';
import { COLOR } from '../../../theme/constants';

export const MetricsTableContainer = styled.div`
   border-radius: 8px;
   border: 1px solid ${COLOR.LIGHTGREY};

   @media (max-width: 1200px) {
      margin: 0 -24px;
      border-radius: 0px;
      border-top: 1px solid ${COLOR.LIGHTGREY};
      overflow-x: auto;
   }
`;

export const Table = styled.table`
   width: 100%;
   border-collapse: separate;
   border-spacing: 0;
   background-repeat: repeat-x;
   clear: both;
   position: relative;

   th {
      min-width: 80px;
   }

   tr td:first-child {
      min-width: 160px !important;
   }
`;
